<template>
  <nav
    v-if="isDesktop"
    class="breadcrumb-nav"
    aria-label="Breadcrumb navigation"
  >
    <ol
      class="breadcrumb c-items-center"
      :class="additionalClassName"
    >
      <li
        v-for="(item, index) in list"
        :key="index"
        :class="`breadcrumb-item${isActive(index)}`"
        :aria-current="index + 1 === list.length ? 'page' : undefined"
      >
        <router-link
          v-if="index + 1 !== list.length"
          :to="item.link"
          :class="{ 'flex': index === 0 }"
        >
          <template v-if="index === 0">
            <span class="sr-only">{{ item.name }}</span>
            <i class="mi-home icon-20 inline" />
          </template>
          <template v-else>
            {{ item.name }}
          </template>
        </router-link>
        <template v-else>
          {{ item.name }}
        </template>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import BrowserService from '@/services/browserService'

const { t } = useI18n()

const props = defineProps({
  additionalClassName: {
    type: String,
    default: '',
  },

  breadcrumbList: {
    type: Array,
    default: () => [],
  },
})

const list = computed(() => {
  return [
    {
      name: t('home'),
      link: { name: 'rootPath' },
    },
    ...props.breadcrumbList,
  ]
})

const isDesktop = computed(() => {
  return BrowserService.isDesktop()
})

const isActive = (index) => {
  return index + 1 === list.value.length ? ' active' : ''
}
</script>

<style lang="scss">
.breadcrumb{
	a:not(:hover){
		text-decoration: none;
		color: $breadcrumb-active-color;
	}
}
.breadcrumb-nav {
  min-height: 40px;
}
</style>

<i18n>
  {
    "cs": {
    "home": "Domů"
},
    "sk": {
    "home": "Domov"
},
    "pl": {
    "home": "? na górę?"
},
    "hu": {
    "home": "Kezdőlap"
},
    "de": {
    "home": "Zuhause"
},
    "at": {
    "home": "Zuhause"
},
    "ro": {
    "home": "Pagina principală"
},
    "fr": {
    "home": "Accueil"
},
    "it": {
    "home": "A casa"
}
  }
</i18n>
